import { Routes, Route } from 'react-router-dom';
import { DetalhePermissoesPage } from '../pages/permissoes/DetalhePermissoesPage';

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/detalhe/:id' element={<DetalhePermissoesPage />} />
    </Routes>
  );
}
